import React from 'react'
import { createContext } from 'react'

const Mycontext = createContext()

export default Mycontext